import { Assessment, RemediationQuestionAnswer } from './assessment.interface';
import { Domain } from './domain.interface';
import { Badge } from './users.interface';
import { WorkflowTypeKey } from './workflow.interface';

export interface Questionnaire {
  id: number;
  title: string;
  description: string;
  version: string;
  slug: string;
  domains: Domain[];
  errors?: any;
  isPublished?: boolean;
  type?: string;
  versions?: Questionnaire[];
  bestPracticeGuidanceLink?: string;
  includeInReporting?: boolean;
  archiveDate?: Date | null;
  // Workflow presentation values served by the API (MPA BP questionnaires only).
  workflowType?: string | null;
  workflowLabel?: string | null;
  sortOrder?: number;
  // How TPN Admin remediation verification is scoped (only the historical 5.3.0
  // questionnaire is 'verification_list'; everything else verifies all remediations).
  verificationScope?: string;
}

export interface QuestionnaireResultArray {
  count: number;
  next: string;
  previous: string;
  results: Questionnaire[];
}

export enum ReportVersion {
  v5_1 = '5.1.0',
  v5_2 = '5.2.0',
  v5_3 = '5.3.0',
  v5_3_1 = '5.3.1',
}

export interface AssignedTpnAdminReviewer {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface RemediationValidationAdminRow {
  id: number;
  application: any | null;
  assessment: Assessment;
  assessmentSurvey: number;
  assessor: number;
  assignedAssessor: number;
  assignedTpnAdminReviewer: AssignedTpnAdminReviewer;
  badges: Badge[];
  baseline: number;
  bpSurvey: number;
  createdAt: string;
  data: any | null;
  isActive: boolean;
  latestControlsUpdatedAt: string;
  newAssessment: boolean;
  questionnaireVersion: string;
  questionsToValidateCount: number;
  remediationQuestionAnswers: RemediationQuestionAnswer[];
  reportIssueDate: string;
  serviceProvider: number;
  serviceProviderAdmin: string;
  serviceProviderName: string;
  site: number;
  siteOrAppName: string;
  status: string;
  subControlsRejectedCount: number;
  subControlsRemediationPlanWillRemediateLaterCount: number;
  subControlsToValidateCount: number;
  subControlsWithEvidenceCount: number;
  updatedAt: string;
  version: string | null;
  workflowType: WorkflowTypeKey;
}